<!-- The new syntax is elegant, but it is farer from what is rendered on screen. Inlined conditions etc resemble more rendered hierarchy -->

@if (state$ | async; as state) {
  <div class="page-header">
    <div class="page-title">BOM</div>

    <div class="header-toolbar">
      <input class="search-input" type="text" placeholder="Szukaj po nazwie, numerze lub opisie…" #search
        (input)="onSearchInput(search.value)">

      <button class="btn" #typeFilterTrigger>Typ: {{ state.typeFilter ? typeLabels[state.typeFilter] : 'Wszystkie' }}</button>

      <button class="btn" #structureFilterTrigger>Struktura: {{ state.structureFilter ? structureLabels[state.structureFilter] : 'Wszystkie' }}</button>

      <a class="btn" [routerLink]="['/bom', 'new']">+ Nowy produkt</a>

      @if (canWriteBom()) {
        <a class="btn" [routerLink]="['/bom', 'import']">Importuj…</a>
      }
    </div>
  </div>

  <dropdown [searchFunc]="searchTypeOptions" [searchFormatter]="formatTypeOption" [trigger]="typeFilterTrigger"
    [minSearchLength]="0" [debounceMs]="0" header="TYP" (itemSelected)="onTypeSelected($event)"></dropdown>

  <dropdown [searchFunc]="searchStructureOptions" [searchFormatter]="formatStructureOption" [trigger]="structureFilterTrigger"
    [minSearchLength]="0" header="STRUKTURA" (itemSelected)="onStructureSelected($event)"></dropdown>

  <!-- the panel, the count line and the table with its header row are the layout; the rows and the count are
       the data, drawn as shadows until it lands (0128) -->
  <div class="list-panel">
    <div class="list-count">
      @if (state.loading) {
        <span class="shadow"></span>
      } @else if (state.items) {
        {{ state.totalCount }} poz.
      }
    </div>

    <div class="list-table" #listTable>
      <div class="list-row list-row-header bom-row">
        <div class="list-cell"></div>
        <div class="list-cell">Numer</div>
        <div class="list-cell">Nazwa</div>
        <div class="list-cell">Opis</div>
        <div class="list-cell">Typ</div>
        <div class="list-cell">Struktura</div>
        <div class="list-cell list-cell-right">#</div>
      </div>

      @if (state.loading) {
        <!-- five rows of the page's own row, at its height: the 28px photo slot holds it (0128) -->
        @for (row of shadowRows; track row) {
          <div class="list-row list-row-shadow bom-row">
            <div class="shadow shadow-photo"></div>
            <div class="list-cell"><span class="shadow shadow-short"></span></div>
            <div class="list-cell"><span class="shadow shadow-long"></span></div>
            <div class="list-cell"><span class="shadow"></span></div>
            <div class="list-cell"><span class="shadow shadow-short"></span></div>
            <div class="list-cell"><span class="shadow shadow-short"></span></div>
            <div class="list-cell list-cell-right"><span class="shadow shadow-short"></span></div>
          </div>
        }
      } @else if (state.items) {
        @for (item of state.items; track item.id) {
          <a class="list-row bom-row" [routerLink]="['/bom', item.id]">
            <item-photo [attachmentId]="item.primaryPhotoAttachmentId" [label]="item.name"></item-photo>
            <div class="list-cell bom-row-part-number text-mono" [title]="item.partNumber ?? ''">{{ item.partNumber ?? '—' }}</div>
            <div class="list-cell bom-row-name" [title]="item.name">{{ item.name }}</div>
            <!-- the one human text a purchased part has (0096); Nazwa repeats Numer for those rows -->
            <div class="list-cell bom-row-description" [title]="item.description ?? ''">{{ item.description ?? '—' }}</div>
            <div class="list-cell bom-row-type">{{ typeLabels[item.type] }}</div>
            <!-- Normalne written out: a dash would read as "not set" -->
            <div class="list-cell bom-row-structure">{{ structureLabels[item.structure] }}</div>
            <div class="list-cell list-cell-right bom-row-id text-mono">#{{ item.id }}</div>
          </a>
        } @empty {
          <!-- An empty catalog gets the invitation regardless of search/filter -->
          @if (state.catalogEmpty) {
            <div class="list-empty">Brak pozycji — zaimportuj zestawienie z Inventora (Importuj…) albo dodaj nowy produkt.</div>
          } @else if (state.search) {
            <div class="list-empty">Brak wyników dla „{{ state.search }}”</div>
          } @else if (state.structureFilter) {
            <div class="list-empty">Brak pozycji o tej strukturze.</div>
          } @else {
            <div class="list-empty">Brak pozycji tego typu.</div>
          }
        }
      }
    </div>

    <!-- the pager needs the answer: it lands under the table and moves nothing above it -->
    @if (!state.loading && state.totalCount > pageSize) {
      @let lastPage = pageCount(state);

      <!-- Real links (0092): open in a new tab and copy link work on a page number too -->
      <div class="pager">
        @if (state.page === 1) {
          <button class="btn btn-small" disabled>‹</button>
        } @else {
          <a class="btn btn-small" [routerLink]="[]" [queryParams]="pageParams(state.page - 1)" queryParamsHandling="merge" [replaceUrl]="true">‹</a>
        }

        @for (entry of pagerPages(state); track $index) {
          @if (entry === '…') {
            <span class="pager-gap">…</span>
          } @else if (entry === state.page) {
            <span class="btn btn-small active" aria-current="page">{{ entry }}</span>
          } @else {
            <a class="btn btn-small" [routerLink]="[]" [queryParams]="pageParams(entry)" queryParamsHandling="merge" [replaceUrl]="true">{{ entry }}</a>
          }
        }

        @if (state.page >= lastPage) {
          <button class="btn btn-small" disabled>›</button>
        } @else {
          <a class="btn btn-small" [routerLink]="[]" [queryParams]="pageParams(state.page + 1)" queryParamsHandling="merge" [replaceUrl]="true">›</a>
        }
      </div>
    }
  </div>
}
